import {Component, HostListener, Inject, ViewContainerRef} from '@angular/core';
import {AuthConfig, OAuthService} from 'angular-oauth2-oidc';
import {AuthorizationService} from './authorization/authorization.service';
import {ImmutableListRepositoryService} from 'src/lib/gelios-field/immutable-list-repository.service';
import {BrowserTabService} from './browser-tab/browser-tab.service';
import {ENVIRONMENT_AUTH_CONFIG} from './auth.config';
import {WebStompService} from './web-stomp/web-stomp.service';
import {environment} from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  constructor(
    private oauthService: OAuthService,
    private authorizationService: AuthorizationService,
    private immutableListRepositoryService: ImmutableListRepositoryService,
    private browserTabService: BrowserTabService,
    private webStompService: WebStompService,
    @Inject(ENVIRONMENT_AUTH_CONFIG) authConfig: AuthConfig,
    public viewContainerRef: ViewContainerRef
  ) {
    this.oauthService.configure(authConfig);
    this.oauthService.setStorage(sessionStorage);
//    if (!this.oauthService.getAccessToken()) {
//      this.oauthService.initImplicitFlow();
//    }
    this.oauthService.tryLogin({disableOAuth2StateCheck: true}).then(
      (result) => {
        if (result) {
          this.oauthService.setupAutomaticSilentRefresh();
          this.authorizationService.requestIdentity();
          this.authorizationService.requestMapSettings();
          this.immutableListRepositoryService
            // .setListNames([
            //   'role',
            //   'unit-type',
            //   'unit-hw-type',
            //   'currency',
            //   'active-billing-period',
            //   'unit-billing-type'
            // ])
            .fetchLists();
        } else {
          this.oauthService.initImplicitFlow();
        }
      }
    );
  }

  title = 'ItemSharingWebAdmin';

  @HostListener('window:focus', ['$event'])
  onFocus(event: any): void {
    this.browserTabService.setStatusActive();
  }

  @HostListener('window:blur', ['$event'])
  onBlur(event: any): void {
    this.browserTabService.setStatusInactive();
  }
}
